import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface CountdownTimerProps {
  variant?: 'default' | 'compact';
}
export function CountdownTimer({
  variant = 'default'
}: CountdownTimerProps) {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 59,
    seconds: 44
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  if (variant === 'compact') {
    return <div className="flex items-center gap-2 text-sm" data-id="element-56">
        <span className="font-mono font-bold text-red-500" data-id="element-57">
          {formatNumber(time.hours)}:{formatNumber(time.minutes)}:
          {formatNumber(time.seconds)}
        </span>
      </div>;
  }
  return <div className="flex justify-center gap-4" data-id="element-58">
      <div className="text-center" data-id="element-59">
        <div className="bg-bg-card border border-red-500 rounded-card px-6 py-4 mb-2" data-id="element-60">
          <span className="text-4xl md:text-5xl font-bold text-red-500 font-mono" data-id="element-61">
            {formatNumber(time.hours)}
          </span>
        </div>
        <span className="text-sm text-text-secondary" data-id="element-62">HS</span>
      </div>
      <div className="text-4xl md:text-5xl font-bold text-red-500 flex items-center" data-id="element-63">
        :
      </div>
      <div className="text-center" data-id="element-64">
        <div className="bg-bg-card border border-red-500 rounded-card px-6 py-4 mb-2" data-id="element-65">
          <span className="text-4xl md:text-5xl font-bold text-red-500 font-mono" data-id="element-66">
            {formatNumber(time.minutes)}
          </span>
        </div>
        <span className="text-sm text-text-secondary" data-id="element-67">MIN</span>
      </div>
      <div className="text-4xl md:text-5xl font-bold text-red-500 flex items-center" data-id="element-68">
        :
      </div>
      <div className="text-center" data-id="element-69">
        <div className="bg-bg-card border border-red-500 rounded-card px-6 py-4 mb-2" data-id="element-70">
          <span className="text-4xl md:text-5xl font-bold text-red-500 font-mono" data-id="element-71">
            {formatNumber(time.seconds)}
          </span>
        </div>
        <span className="text-sm text-text-secondary" data-id="element-72">SEG</span>
      </div>
    </div>;
}